
export const cabinClasses: any = {
  Economy: {
    name: "flight.economy",
    code: "Economy",
  },
  'Business': {
    name: "flight.business",
    code: "Business",
  },
  'First Class': {
    name: "flight.first_class",
    code: "First Class",
  }
}

export const cabinClassNames: any = {
  _9G: {
    "Economy lite": "Economy lite",
    "Economy classic": "Economy classic",
    "Economy flex": "Economy flex",
    "Economy Plus": "Economy Plus",
    "Business Elite": "Business Elite",
    "Business Prime": "Business Prime",
  },
  AK: {
    "E": "Economy",
    "P": "Premium Flex"
  },
  VN: {
    "ECONOMY SUPER LITE": "Phổ Thông Siêu Tiết Kiệm",
    "ECONOMY LITE": "Phổ Thông  Tiết Kiệm",
    "ECONOMY CLASSIC": "Phổ Thông Tiêu Chuẩn",
    "ECONOMY FLEX": "Phổ Thông Linh Hoạt",
    "PREMIUM ECONOMY Standard": "Phổ Thông Đặc Biệt Tiêu Chuẩn",
    "PREMIUM ECONOMY FLEX": "Phổ Thông Đặc Biệt Linh Hoạt",
    "BUSINESS CLASSIC": "Thương Gia Tiêu Chuẩn",
    "BUSINESS FLEX": "Thương Gia Linh Hoạt",
    "PREMIUM ECONOMY CLASSIC": "Phổ Thông Đặc Biệt Tiêu Chuẩn",
  },
  QH: {
    "ECONOMYSAVERMAX": "ECONOMYSAVERMAX",
    "ECONOMYSAVER": "ECONOMYSAVER",
    "ECONOMYSMART": "ECONOMYSMART",
    "ECONOMYFLEX": "ECONOMYFLEX",
    "BUSINESSSMART": "BUSINESSSMART",
    "BUSINESSFLEX": "BUSINESSFLEX",
  },
  VJ: {
    "Eco": "Eco",
    "Deluxe": "Deluxe",
    "SkyBoss": "SkyBoss",
    "Business": "Business",
  },
  JQ: {
    "Starter": "Starter",
    "Starter Flex": "Starter Flex",
    "Starter Plus": "Starter Plus",
    "Starter Max": "Starter Max",
  },
  VU: {
    "Economy Saver": "Phổ Thông Tiết Kiệm",
    "Economy Flex": "Phổ Thông Linh Hoạt",
    "PREMIUM ECONOMY": "Phổ Thông Cao Cấp",
  }
}